<script lang="ts">
</script>

<svelte:head>
  <title>Rules</title>
</svelte:head>

<main>
  <!-- Hero -->
  <section class="px-3.5 md:px-7">
    <div class="bg-primary-off-white py-7 md:py-20 w-full">
      <div class="container-center">
        <div class="text-center">
          <h2
            class="font-hilton-serif text-4xl text-black font-normal leading-120 -tracking-0.72 mb-5"
          >
            Hilton for <u>your</u> Business Sweepstakes
            <br class="hidden md:block" />
            Official Rules
          </h2>
        </div>
      </div>
    </div>
  </section>
  <!-- END hero -->

  <!-- Rules -->
  <section class="px-3.5 md:px-7">
    <div class="py-7 md:py-20 w-full">
      <div
        class="container-center font-normal leading-120 text-black text-lg flex flex-col gap-y-7"
      >
        <p>
          NO PURCHASE IS NECESSARY TO PARTICIPATE OR WIN. A PURCHASE WILL NOT
          IMPROVE YOUR CHANCES OF WINNING. VOID WHERE PROHIBITED BY LAW.
        </p>
        <p>
          YOUR ENTRY IN THIS SWEEPSTAKES MEANS THESE OFFICIAL RULES FORM A
          BINDING LEGAL CONTRACT, SO READ THEM CAREFULLY BEFORE PARTICIPATING.
          WITHOUT LIMITATION, THIS CONTRACT PROVIDES FOR YOUR INDEMNIFICATION OF
          THE SPONSOR AND OTHER PARTIES, THE WAIVER OF THE RIGHTS TO PARTICIPATE
          IN A CLASS ACTION OR A JURY TRIAL, AND A REQUIREMENT THAT MOST
          DISPUTES WILL BE SETTLED BY MANDATORY BINDING ARBITRATION.
        </p>
        <ol class="flex flex-col gap-y-7 list-decimal list-outside">
          <li class="ml-5 marker:font-bold">
            <strong>SWEEPSTAKES PERIOD:</strong> The Hilton For Your Business Sweepstakes
            (the “Sweepstakes”) entry period begins at approximately 12:01 AM Eastern
            Time (“ET”) on December 4, 2024, and ends at 11:59 PM ET on January 11,
            2025 (the “Sweepstakes Period”). Participants must submit their entries
            during the Sweepstakes Period. Administrator is the official timekeeping
            device for the Sweepstakes. Late, incomplete, or otherwise ineligible
            entries will not be considered.
          </li>
          <li class="ml-5 marker:font-bold">
            <strong>ELIGIBILITY: </strong> To be eligible to participate in the Sweepstakes,
            participants (“Participants”) must, at the time of entry, meet all of
            the following requirements: (i) be a legal resident of one of the 50
            United States or D.C. or the United Kingdom (excluding Northern Ireland)
            (“Territory”); (ii) be 18 years of age or older and the age of majority
            in your jurisdiction as of the date and time of participation; (iii)
            be an employee of a small or medium sized business that is registered
            with Hilton for Business with a valid Hilton Honors account number (“Business”).
          </li>
        </ol>
        <p>
          Hilton for Business: It is free to create a Hilton for Business
          account. If you are not already a Hilton Honors Member, you may sign
          up for free at https://www.hilton.com/en/hilton-honors/join/. In order
          to participate in Hilton for Business: 1) the Business must be a legal
          small-to-medium business. The Business must not have a partnership
          relationship with Hilton Worldwide Sales; 2) the Business and the
          Business' employees must be enrolled in Hilton Honors. The Hilton
          Honors account is where you can access and manage your Hilton for
          Business program account.; and 3) the Business and the Business'
          employees must have email addresses that match your work email
          domain—for example, name@company.com. Free email, such as Gmail or
          Yahoo email, are not eligible.
        </p>

        <p>
          Employees, officers, directors, and agents of Hilton Domestic
          Operating Company Inc. (“Sponsor”), Fooji, Inc. (“Administrator”),
          prize suppliers, any other company involved in the presentation,
          administration or fulfillment of the Sweepstakes, and their respective
          subsidiaries, affiliated companies, and divisions (collectively, the
          “Sweepstakes Entities”), as well as their immediate family members
          (defined as a spouse, partner, parent, legal guardian, sibling, child,
          legal ward, grandparent, or grandchild, regardless of residence) and
          those living in the same household (whether related or not), are not
          eligible to enter or win. Void outside the Eligible Territory and
          where prohibited or restricted by law.
        </p>

        <ol class="flex flex-col gap-y-4 list-decimal list-outside" start="3">
          <li class="ml-5 marker:font-bold">
            <strong>SPONSOR:</strong> The Sponsor of the Sweepstakes is Hilton Domestic
            Operating Company Inc. with offices at 7930 Jones Branch Dr, McLean,
            VA 22102 (“Sponsor”). The Administrator of the Sweepstakes is Fooji,
            Inc. located at 257 E. Short St. Suite 200, Lexington, KY 40507 (“Administrator”).
          </li>
          <li class="ml-5 marker:font-bold">
            <strong>HOW TO PARTICIPATE IN THE SWEEPSTAKES: </strong>
            To participate and receive one (1) entry in the Sweepstakes: (i) Access
            the online entry form by either (a) clicking the link posted in the applicable
            @hiltonhonors call-to-action Instagram post, (b) clicking the link in
            a promotional email from Sponsor, (c) clicking the link displayed on
            Sponsor’s website at https://www.HiltonForBusiness.com, (d) scanning
            the QR code at Hilton sponsored events, or (e) by visiting the sweepstakes
            landing page at https://hilton-for-your-business-sweeps.prod.fooji.com;
            (ii) If the Sweepstakes is still ongoing, you will be redirected to the
            online entry form; (iii) You must enter a valid Hilton Honors account
            number associated with your applicable Business, and (iv) You must fully
            complete the entry form by providing your name, physical address (no
            P.O. Boxes), Business email address (“free mail” not acceptable), and
            phone number, and submit to Fooji a completed registration form for its
            receipt.
          </li>
        </ol>
        <p>
          This Sweepstakes is in no way sponsored, endorsed, or administered by
          or associated with Meta Platforms, Inc. (Instagram).
        </p>
        <p>
          NOTE ABOUT MOBILE DATA AND MESSAGING CHARGES: When you participate in
          the Sweepstakes via a mobile device and/or download or transmit data
          via your mobile device, data and messaging rates may apply according
          to the terms and conditions of your service agreement with your
          wireless carrier. Other charges may apply (such as normal airtime and
          carrier charges) and may appear on your mobile phone bill or be
          deducted from your prepaid account balance. Wireless carriers' rate
          plans may vary, and you should contact your wireless carrier for more
        </p>

        <ol class="flex flex-col gap-y-7 list-decimal list-outside" start="5">
          <li class="ml-5 marker:font-bold">
            <strong>Prize: </strong> The following Prizes are available to be
            awarded to the winning Business:
            <ol
              class="flex flex-col gap-y-7 ml-5 list-decimal list-outside marker:font-normal"
              start="1"
            >
              <li>
                <u>Grand Prize:</u> There is one (1) Grand Prize available. The Grand
                Prize consists of $50,000 to be delivered to the applicable Business
                (for clarity, the monetary component of the Prize will not be delivered
                to the Participant personally), (5) "Be My Guest" vouchers valid
                for (1) night each at any participating Hilton property for Grand
                Prize winner and one (1) guest (one room, double occupancy), and
                one (1) Instant Hilton Diamond Status (defined below). Grand Prize
                winner must use the hotel stay by December 31, 2025. Blackout dates
                apply. “Be My Guest” vouchers are not valid at Small Luxury Hotels
                (“SLH”). Additional terms and restrictions may apply. Approximate
                Retail Value (“ARV”) of Grand Prize: $59,500.
              </li>
              <li>
                <u>Secondary Prizes:</u> There are two (2) Secondary Prizes available.
                Each Secondary Prize consists of $25,000 to be delivered to the applicable
                Business (for clarity, the monetary component of the Prize will not
                be delivered to the Participant personally) and one (1) Instant Hilton
                Diamond Status. ARV of each Secondary Prize: $34,500.
              </li>
              <li>
                <u>Additional Prizes:</u> There are twenty (20) Additional Prizes
                available. Each Additional Prize is one (1) Diamond Fast Track Promotion
                (defined below). ARV of each Additional Prize: $7,600.
              </li>
            </ol>
          </li>
        </ol>
        <p>
          Grand Prize, Secondary Prizes, and Additional Prizes are collectively
          referred to as “Prize(s).” Total ARV of all Prizes available in this
          Sweepstakes: $280,500.
        </p>
        <p>
          All federal, state, and local taxes (or international taxes, if
          applicable) and all other expenses not expressly listed in these
          Official Rules are the sole responsibility of the Prize winner(s).
          Prize is nontransferable and may not be substituted or redeemed for
          cash by Prize winner(s). No more than the stated number of Prizes will
          be awarded. Sponsor reserves the right to substitute the Prize for one
          of equal or greater value. Gift cards, vouchers, and travel
          certificates are subject to their own separate terms and conditions.
          All non-stated features of the Prize(s) are determined in Sponsor’s
          sole discretion and subject to availability.
        </p>
        <p>
          Instant Diamond Status: Consists of instant Diamond status through
          March 31, 2027. Diamond status will be awarded on January 15, 2025.
          All offer components are non-transferable or redeemable for cash. Void
          where prohibited by law. Not valid for current employees of Hilton.
        </p>
        <p>
          Diamond Fast Track Promotion: Upon award of the Diamond Fast Track
          promotion, members will earn instant Diamond status and maintain such
          status for 90 days. Additionally, members who complete 6 nights during
          their 90 days promotion period will receive Gold status through March
          31, 2027. Members who complete 12 nights during their 90 day promotion
          period will achieve Diamond status through March 31, 2027. Members who
          do not complete their Gold or Diamond fast track requirements will be
          downgraded to the tier they held previously. All offer components are
          non-transferable or redeemable for cash.
        </p>
        <p>
          Additional Grand Prize Terms: Verified Grand Prize winner and his/her
          guest must commence and complete the stay by the dates specified by
          Sponsor (exclusions/blackout dates apply). Verified Grand Prize winner
          and his/her guest must travel on the same itinerary. If verified Grand
          Prize winner is unable to travel on the dates booked and/or provided
          by Sponsor, the Grand Prize will be forfeited and no additional prize
          will be awarded. All travel-related and other expenses not set forth
          herein, including but not limited to meals, ground and other
          transportation, parking, gratuities and incidental hotel expenses, are
          the sole responsibility of verified Grand Prize winner. Both the
          verified Grand Prize winner and his/her guest must be 18 years or
          older. Verified Prize winner and his/her guest will be required to
          sign a release before going on the trip. Verified Grand Prize winner
          and his/her guest are responsible for obtaining any valid
          documentation necessary for travel (for example, passport and/or
          visa), and each is responsible for his/her own travel insurance should
          they desire the same. Use of Grand Prize is conditioned upon verified
          Grand Prize winner and his/her guest conducting themselves at all
          times in a socially responsible, respectful and appropriate manner;
          should verified Prize winner and/or his/her guest fail to do so, Grand
          Prize may be immediately terminated and Sponsor may pursue other legal
          sanctions against the verified Grand Prize winner and/or his/her
          guest, as applicable.  Further travel and/or accommodations
          restrictions may apply.
        </p>
        <p>
          “Be My Guest” Vouchers: “Be My Guest” vouchers are valid for update to
          one (1) year from the issue date printed on the certificate. “Be My
          Guest” vouchers are not valid for New Year’s Eve. Additional Terms and
          Conditions apply.
        </p>

        <ol class="flex flex-col gap-y-7 list-decimal list-outside" start="6">
          <li class="ml-5 marker:font-bold">
            <strong>WINNER SELECTION: </strong>Odds of winning a Prize in this
            Sweepstakes depend on the number of Participants. Fooji will be the
            official time keeping device for the Sweepstakes and all decisions
            by the Administrator regarding the timing of entries and the order
            in which they are received will be final and binding. Subject to
            compliance with these Official Rules, entries will be accepted
            throughout the Sweepstakes Period. Participants are limited to one
            entry during the Sweepstakes Period.
          </li>
        </ol>
        <p>
          At the end of the Sweepstakes Period, on or about January 15, 2025,
          Administrator will conduct a random drawing supervised by an
          independent person and select one (1) potential Grand Prize winner,
          two (2) potential Secondary Prize winners, and 20 potential Additional
          Prize winners (each a “Potential Prize Winner”).
        </p>
        <p>
          If you are chosen as a Potential Prize Winner, you will receive a
          winning notification via email using the email address used to enter
          the Sweepstakes indicating that you are a Potential Prize Winner.
          Participants selected as winners are limited to one (1) Prize per
          person and per delivery address during the Sweepstakes Period. Local
          merchants that participate in the fulfillment partner network may
          provide fulfillment and delivery of the Prize(s).  Prize availability
          may vary and is not guaranteed in all areas.  Except as determined by
          Sponsor in its sole discretion, no substitution of any Prize is
          offered, no transfer of Prize to a third party is permitted, and
          non-cash Prize(s) may not be redeemed for cash value.  AS SET FORTH
          ABOVE, YOU MUST RESIDE IN THE TERRITORY IN ORDER TO BE ELIGIBLE TO
          PARTICIPATE IN THIS SWEEPSTAKES AND WIN A PRIZE.  Verified Prize
          winner(s) will be solely responsible for all applicable federal, state
          and local taxes on Prize(s) and may receive an IRS Form 1099 for the
          retail value of the Prize and must provide Sponsor with a valid social
          security number if requested for tax reporting purposes. All expenses
          associated with the receipt and use of a Prize not specifically
          mentioned herein are solely the responsibility of the winners. Sponsor
          is not responsible for any delay or cancellation of the Prize delivery
          due to unforeseen circumstances, or those outside of Sponsor’s
          control. If the fulfilling merchant cancels the order for reasons out
          of Sponsor’s control, the Prize will not be delivered, and no
          additional compensation will be provided. Potential winners are
          subject to verification and may be required to sign and return to
          Sponsor for its receipt within three (3) business days an Affidavit of
          Eligibility/ Liability Release with (where lawful) a publicity release
          for receipt by Sponsor by the due date indicated in the notification
          message. If any required documents are not timely received by Sponsor,
          or if any message or mail intended for a winner is returned as
          undeliverable, then the applicable Prize may be forfeited.  Any
          request related to lost, mutilated, missing, unclaimed or stolen
          prize(s) must be received within 14 days of notification of winning or
          will be ignored.
        </p>

        <ol class="flex flex-col gap-y-7 list-decimal list-outside" start="7">
          <li class="ml-5 marker:font-bold">
            <strong>General Rules / Limitations of Liability:</strong>
            participating in the Sweepstakes, Participants agree to be bound by these
            Official Rules and the decisions of the Sponsor, which shall be final
            in all respects. Participation in the Sweepstakes constitutes permission
            for the Sponsor and its designees to use the Participant’s name, likeness,
            voice, biographical information, prize information, quotes attributable
            to Participant, and any other elements of Participant’s persona for purposes
            of advertising and trade in any and all media now known or otherwise
            developed without further compensation or review, including a Participant
            list to be used by Fooji and its partners to re-target participants via
            email unless prohibited by law. By clicking “Enter Now,” Participants
            authorize Fooji or their fulfillment partners to send emails, text messages
            or phone calls notifying Participants of delivery details for their order.
            Participants agree that Fooji or the Fulfillment Partner may send the
            notice to the telephone number the Participant provides during the registration
            process, and Participants understand notifications will be sent using
            automatic dialing technology. Participants understand that they are not
            required to agree to receive such messages as a condition of participation.
            In the event there is a discrepancy or inconsistency between disclosures
            or other statements (in any and all media) contained in any Sweepstakes
            materials and the terms and conditions of the Official Rules, the Official
            Rules shall prevail, govern and control. Sponsor and the other Sweepstakes
            Entities assume no responsibility or liability for (a) any incorrect
            or inaccurate entry information, or for any faulty, failed, garbled or
            jumbled electronic data transmissions; (b) any unauthorized access to,
            or theft, destruction or alteration of entries at any point in the operation
            of this Sweepstakes; (c) any technical malfunction, failure, error, omission,
            interruption, deletion, defect, delay in operation or communications
            line failure, regardless of cause, with regard to any equipment, systems,
            networks, lines, satellites, servers, computers, software or providers
            utilized in any aspect of the operation of the Sweepstakes; (d) inaccessibility
            or unavailability of the Internet or any combination thereof; (e) any
            injury or damage to Participant's or to any other person's computer which
            may be related to or resulting from any attempt to participate in the
            Sweepstakes; (f) any other claims related to participation in the Sweepstakes,
            including without limitation any claims of intellectual property infringement,
            violation of any rights of privacy or publicity or any personal injury
            or property damage; or (g) other errors or difficulties of any kind whether
            human, mechanical, electronic, computer, network, typographical, printing
            or otherwise relating to or in connection with the Sweepstakes, including,
            without limitation, errors or difficulties which may occur in connection
            with the administration of the Sweepstakes, the processing online entry
            forms, the announcement of the Prize or in any Sweepstakes-related materials.
            The Sponsor, Administrator and other Sweepstakes Entities are not responsible
            for the failure of any order to be received for any reason or for any
            delay in the processing or failure to process any order or entries. The
            Sponsor reserves the right at its sole discretion to disqualify any individual
            that tampers or attempts to tamper with the order process or the operation
            of the Sweepstakes; violates the Official Rules; is suspected of cheating,
            fraud, or acting in an unsportsmanlike or disruptive manner, or with
            intent to annoy, abuse, threaten or harass any other person. Any Participant
            who uses or is suspected of using cheating, fraudulent means, unauthorized
            ordering methods, or otherwise attempts to participate multiple times,
            or with multiple identities, and/or addresses will be disqualified. Any
            attempt by any person to undermine the legitimate operation of the Sweepstakes
            may be a violation of criminal and civil law, and should such an attempt
            be made, the Sponsor reserves the right to seek damages from any such
            person to the fullest extent permitted by law. The Sponsor's failure
            to enforce any term of these Official Rules shall not constitute a waiver
            of that or any other provision. If, for any reason, the Sweepstakes is
            not capable of running as planned, including infection by computer virus,
            bugs, tampering, unauthorized intervention, fraud, technical failures,
            or any other causes beyond the control of the Sponsor which corrupt or
            affect the administration, security, fairness, integrity or proper conduct
            of the Sweepstakes, then the Sponsor reserves the right in its sole discretion
            to cancel, modify, suspend or terminate the Sweepstakes in whole or in
            part. In the event Sponsor experiences a technical failure during admission
            of the Sweepstakes that causes the Sweepstakes to be suspended, Administrator
            shall select a winner(s) by random drawing from all valid entries received
            up to the point of the technical failure. TO THE FULLEST EXTENT PERMITTED
            BY LAW, AS A CONDITION OF ENTRY INTO THE SWEEPSTAKES, ALL PARTICIPANTS
            AGREE TO RELEASE, INDEMNIFY AND HOLD HARMLESS THE SPONSOR, ADMINISTRATOR,
            AND OTHER SWEEPSTAKES ENTITIES FROM AND AGAINST ANY AND ALL LIABILITY,
            CLAIMS OR ACTIONS OF ANY KIND WHATSOEVER FOR INJURIES, DAMAGES, OR LOSSES
            TO PERSONS OR PROPERTY WHICH MAY BE SUSTAINED IN CONNECTION WITH: PARTICIPATING
            IN ANY ASPECT OF THE SWEEPSTAKES; THE RECEIPT, OWNERSHIP OR USE OF ANY
            PRIZE AWARDED; PREPARING FOR, PARTICIPATING IN OR TRAVELING TO AND/OR
            FROM ANY PRIZE- RELATED OR SWEEPSTAKES-RELATED ACTIVITY, OR; ANY TYPOGRAPHICAL
            OR OTHER ERROR IN THESE OFFICIAL RULES OR ANY CTA POSTS OR OTHER ANNOUNCEMENTS
            RELATING TO THE SWEEPSTAKES. THE WINNERS SHALL BEAR ALL RISK OF LOSS
            OR DAMAGE TO THEIR PRIZE AFTER THEY HAVE BEEN DELIVERED. SPONSOR AND
            THE OTHER SWEEPSTAKES ENTITIES MAKE NO REPRESENTATIONS OR WARRANTIES
            OF ANY KIND CONCERNING THE APPEARANCE, SAFETY OR PERFORMANCE OF ANY PRIZE(S).
            <br />
            <br />
            BY ENTERING THE SWEEPSTAKES, PARTICIPANT AGREES THAT, TO THE FULLEST
            EXTENT PERMITTED BY APPLICABLE LAW: (1) ANY AND ALL DISPUTES, CLAIMS
            AND CAUSES OF ACTION ARISING OUT OF OR CONNECTED WITH THE SWEEPSTAKES,
            OR ANY PRIZE(S) AWARDED WILL BE LIMITED TO ACTUAL, OUT-OF-POCKET COSTS
            INCURRED (IF ANY) NOT TO EXCEED TEN DOLLARS ($10.00), BUT IN NO EVENT
            WILL ATTORNEYS’ FEES BE AWARDED OR RECOVERABLE; AND (2) UNDER NO CIRCUMSTANCES
            WILL ANY PARTICIPANT BE PERMITTED TO OBTAIN ANY AWARD FOR, AND PARTICIPANT
            HEREBY KNOWINGLY AND EXPRESSLY WAIVES ALL RIGHTS TO SEEK, PUNITIVE, INCIDENTAL,
            CONSEQUENTIAL OR SPECIAL DAMAGES, LOST PROFITS AND/OR ANY OTHER DAMAGES
            (OTHER THAN ACTUAL OUT-OF-POCKET EXPENSES NOT TO EXCEED TEN DOLLARS ($10.00))
            AND/OR ANY RIGHTS TO HAVE DAMAGES MULTIPLIED OR OTHERWISE INCREASED. 
            SOME JURISDICTIONS DO NOT ALLOW THE FOREGOING LIMITATIONS OR EXCLUSION
            OF LIABILITY, SO THE ABOVE MAY NOT APPLY TO YOU.
            <br />
            <br />
            Without limiting any other provision in these Official Rules, the Sweepstakes
            Entities are not responsible or liable to any Participant or winner (or
            any person claiming through such Participant or winner) for failure to
            supply the prize or any part thereof in the event that any of the Sweepstakes
            activities or Sweepstakes Entities’ operations or activities are affected
            by any cause or event beyond the sole and reasonable control of the applicable
            Sweepstakes Entity (as determined by Sponsor in its sole discretion),
            including, without limitation, by reason of any acts of God, equipment
            failure, threatened or actual terrorist acts, air raid, act of public
            enemy, war (declared or undeclared), civil disturbance, insurrection,
            riot, epidemic, pandemic, fire, explosion, earthquake, flood, hurricane,
            unusually severe weather, blackout, embargo, labor dispute or strike
            (whether legal or illegal), labor or material shortage, transportation
            interruption of any kind, work slow-down, any law, rule, regulation,
            action, order, or request adopted, taken, or made by any governmental
            or quasi-governmental entity (whether or not such governmental act proves
            to be invalid), or any other cause, whether or not specifically mentioned
            above.
            <br />
            <br />
            EACH PARTICIPANT UNDERSTANDS AND AGREES THAT ALL RIGHTS UNDER SECTION
            1542 OF THE CIVIL CODE OF CALIFORNIA AND ANY SIMILAR LAW OF ANY STATE
            OR TERRITORY OF THE UNITED STATES ARE HEREBY EXPRESSLY WAIVED BY HIM/HER
            AGAINST THE SWEEPSTAKES ENTITIES.  SECTION 1542 READS AS FOLLOWS:
            <br />
            <br />
            “CERTAIN CLAIMS NOT AFFECTED BY A GENERAL RELEASE. A GENERAL RELEASE
            DOES NOT EXTEND TO CLAIMS THAT THE CREDITOR OR RELEASING PARTY DOES NOT
            KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING
            THE RELEASE, AND THAT IF KNOWN BY HIM OR HER WOULD HAVE MATERIALLY AFFECTED
            HIS OR HER SETTLEMENT WITH THE DEBTOR OR RELEASED PARTY.”
          </li>
          <li class="ml-5 marker:font-bold">
            <strong>Privacy Policy:</strong> By entering the Sweepstakes, Participants
            agree that any personal information submitted by Participants may be
            used and shared by Sponsor subject to Sponsor’s privacy policy posted
            at: https://www.hilton.com/en/p/global-privacy-statement/, and Fooji’s
            privacy policy posted at https://www.fooji.com/privacy/.
          </li>
          <li class="ml-5 marker:font-bold">
            <strong
              ><u>BINDING ARBITRATION AGREEMENT AND CLASS ACTION WAIVER:</u
              ></strong
            >
            Except where prohibited by law, as a condition of participating in this
            Sweepstakes, each Participant agrees as follows:
            <br />
            <br />
            Binding Arbitration Agreement. Except as otherwise stated below, any
            and all legal issue, claim or dispute arising out of or connected or
            related in any way to the Sweepstakes, including but not limited to Prize
            awarded, shall be resolved through final, binding arbitration. Participant
            specifically agrees that, except as otherwise provided herein, entry
            into the Sweepstakes waives all rights to bring a lawsuit based on such
            claim(s) or dispute(s) and the right to have such lawsuit resolved by
            a judge or a jury.
          </li>
        </ol>
        <p>
          This Arbitration Agreement shall be governed by the Federal
          Arbitration Act, (9 U.S.C. § 1 et seq.). Any arbitration will be
          commenced and administered by JAMS under the rules of JAMS, including
          JAMS Consumer Arbitration Minimum Standards
          https://www.jamsadr.com/consumer-minimum-standards/. If JAMS’ criteria
          are met by the nature of the dispute, the Participant agrees that the
          arbitration shall be conducted under JAMS Streamlined Arbitration
          Rules & Procedures
          https://www.jamsadr.com/rules-streamlined-arbitration/. Judgment upon
          any arbitration award may be entered in any court of appropriate
          jurisdiction.
        </p>
        <p>
          Each party will pay the fees for his/her or its own attorneys, subject
          to any remedies to which that party may later be entitled under
          applicable law. However, if Participant is unable to pay JAMS’ costs,
          Sponsor will pay all arbitration fees and expenses. If JAMS is
          unavailable, unwilling, or otherwise unable to administer an
          arbitration in accordance with these rules, then another arbitration
          administrator will do, to be selected by agreement of the parties.
        </p>
        <p>
          Neither Participant nor Sponsor shall be permitted to obtain awards,
          and all parties hereby waive all rights to claim, punitive, incidental
          or consequential damages, or any other damages, including attorneys’
          fees, other than Participant’s actual out-of-pocket expenses (i.e.,
          costs associated with participating in this Sweepstakes). The parties
          further waive all rights to have damages multiplied or increased.
        </p>
        <p>
          The arbitrator has the same authority to award relief on an individual
          basis that a judge in a court of law would have.  The award of the
          arbitrator is final and binding upon both you and us. Additionally,
          the arbitrator, and not any federal, state, or local court or agency,
          shall have the exclusive authority to resolve any dispute relating to
          the interpretation, applicability, enforceability, or formation of
          this Arbitration Agreement, except that this sentence shall not apply
          to the Class Action Waiver provisions described below. The arbitrator
          will render a decision in writing. A court of competent jurisdiction
          shall have the authority to enter judgment upon the arbitrator's
          decision/award. This Arbitration Agreement will survive the
          termination of your relationship with us.
        </p>
        <p>
          <strong><u>Excluded Disputes.</u></strong>  Notwithstanding the
          binding arbitration requirement set forth in this section, Participant
          may bring qualifying claims in small claims court so long as the
          matter remains in such court and advances only on an individual,
          non-class, non-representative basis.
        </p>
        <p>
          <strong><u>Class Action Waiver.</u></strong> To fullest extent permitted
          by applicable law, you and we agree to bring any claim or dispute, whether
          in arbitration, or court as permitted by these terms, ON AN INDIVIDUAL
          BASIS ONLY, AND NOT AS A CLASS ACTION OR COLLECTIVE ACTION. There shall
          be no right or authority for any claim or dispute to be brought, heard
          or arbitrated as a class or collective action ("Class Action Waiver").
          The arbitration will decide the rights and liabilities, if any, of you
          and us.  The arbitration proceeding will not be consolidated with any other
          matters or joined with any other cases or parties. The arbitrator may award
          any remedy to which a party is entitled under applicable law, but remedies
          shall be limited to those that would be available to a party in their individual
          capacity. Regardless of anything else in this Arbitration Agreement and/or
          the applicable JAMS rules, the interpretation, applicability, enforceability
          or formation of the Class Action Waiver may only be determined by a court
          and not an arbitrator. This Class-Action Waiver will survive the termination
          of your relationship with us.
        </p>
        <p>
          <strong
            ><u>One-Year Time Limit to Raise Disputes or Claims.</u></strong
          >
          You agree that any dispute, claim or lawsuit, regardless of form, that
          may arise out of or related to the Sweepstakes, must be filed within ONE
          (1) YEAR of the action, omission, event or occurrence giving rise to the
          dispute, claim(s) or lawsuit. After the expiration of the one-year period,
          such dispute, claim(s) or lawsuit will be time-barred and prohibited, without
          regard to any longer period of time which may be provided by any period
          of limitation or pursuant to law or statute.
        </p>
        <p>
          <strong><u>Waiver of Jury Trial.</u></strong>  BOTH PARTICIPANT AND
          SPONSOR HEREBY WAIVE ANY CONSTITUTIONAL AND STATUTORY RIGHTS TO SUE IN
          COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR A JURY, except as
          provided herein.  We are instead mutually electing that all disputes,
          claims, or requests for relief shall be resolved by arbitration under
          this Arbitration Agreement, except as specified herein.  An arbitrator
          can award on an individual basis the same damages and relief as a
          court and must follow this Agreement as a court would.  However, there
          is no judge or jury in arbitration, and court review of an arbitration
          award is subject to very limited review.
        </p>
        <p>
          <strong><u>Location of Arbitration.</u></strong>
          Participant may choose to have the arbitration conducted by video conference
          technology such as zoom, or based on written submissions. Otherwise, the
          location of the arbitration proceeding shall take place in the city or
          state where Participant resides, unless each party to the arbitration agrees
          otherwise, or at another mutually agreed upon location
        </p>

        <ol class="flex flex-col gap-y-7 list-decimal list-outside" start="10">
          <li class="ml-5 marker:font-bold">
            <strong>Governing Law:</strong>
            These Official Rules and any disputes between us shall be governed by
            the laws of the State of New York without giving effect to any choice
            of law or conflict of law rules (whether of the State of New York or
            any other jurisdiction), which would cause the application of the laws
            of any jurisdiction other than the State of New York.
          </li>
          <li class="ml-5 marker:font-bold">
            <strong>Severability: </strong>If any term of provision of these
            Official Rules is found under the law to be invalid or
            unenforceable, then such specific term or provision shall be of no
            force and effect and shall be severed and the remainder of these
            Official Rules shall continue in full force and effect.
          </li>
          <li class="ml-5 marker:font-bold">
            <strong>Winners List: </strong>For a winners’ list, no later than 60
            days after the close of the Sweepstakes, send an email request with
            the name of the Sweepstakes to hello@fooji.com or mail your request
            together with a self-addressed stamped envelope to Hilton For Your
            Business Sweepstakes Winner’s List to Administrator at the address
            noted in Section 3 above.
          </li>
        </ol>
        <p>
          Questions?  If you have any questions, you may contact us at
          help@fooji.com.
        </p>
        <p>
          <strong>NO PURCHASE NECESSARY.</strong> Void where prohibited. Open to
          legal residents of the 50 U.S., D.C., and the United Kingdom (excluding
          Northern Ireland) who are 18 years or older and meet the eligibility criteria.
          Begins 12/4/24 at 12:00 p.m. ET and ends 1/11/25 at 11:59 p.m. ET. Prize/Odds:
          Total ARV of all prizes is $280,500 USD. Odds of winning depend on the
          total number of eligible entries received. Subject to Official Rules located
          at https://hilton-for-your-business-sweeps.prod.fooji.com. Sponsor: Hilton
          Domestic Operating Company Inc., 7930 Jones Branch Dr, McLean, VA 22102.
          Administrator: Fooji, Inc., 257 E. Short St. Suite 200, Lexington, KY 40507.
        </p>
      </div>
    </div>
  </section>
  <!-- END rules -->
</main>
